<template>
    <div class="results-recently-opened">
        <component
            :is="componentName(result)"
            v-for="(result, index) in results.slice(0, 8)"
            :key="index"
            v-bind="result.items"
            context="recently-viewed"
        />
    </div>
</template>
<script>
import SearchResultsCompany from 'vcomponents/searchbar/results/SearchResultsCompany.vue';
import SearchResultsIndividual from 'vcomponents/searchbar/results/SearchResultsIndividual.vue';
import SearchResultsContact from 'vcomponents/searchbar/results/SearchResultsContact.vue';
import SearchResultsOpportunity from 'vcomponents/searchbar/results/SearchResultsOpportunity.vue';
import SearchResultsItem from 'vcomponents/searchbar/results/SearchResultsItem.vue';
import SearchResultsTicket from 'vcomponents/searchbar/results/SearchResultsTicket.vue';
import SearchResultsDocument from 'vcomponents/searchbar/results/SearchResultsDocument.vue';

export default {
    name: 'ResultsRecentlyOpened',
    components: {
        SearchResultsCompany,
        SearchResultsIndividual,
        SearchResultsContact,
        SearchResultsOpportunity,
        SearchResultsItem,
        SearchResultsTicket,
        SearchResultsDocument,
    },
    props: {
        results: {
            type: Array,
            required: true,
        },
    },
    computed: {
        componentName() {
            return (item) => {
                let component;
                switch (item.key) {
                    case 'redactor':
                        component = `search-results-document`;
                        break;
                    default:
                        component = `search-results-${item.key}`;
                        break;
                }
                return component;
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.results-recently-opened {
    &:not(:first-child) {
        &:before {
            content: '';
            background: var(--colors-common-border-lighter, #e9e9ec);
            display: block;
            height: 1px;
            margin: var(--spacing-0) var(--spacing-3) var(--spacing-3);
        }
    }
}
</style>
